import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Target, Users, Zap } from "lucide-react";

const heroImg = "https://images.pexels.com/photos/4832564/pexels-photo-4832564.jpeg?auto=compress&cs=tinysrgb&w=1400";

export default function About() {
  return (
    <div className="min-h-screen bp-grid">
      <Navbar />
      <section className="relative overflow-hidden border-b border-border">
        <img src={heroImg} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/50 to-background" />
        <div className="relative mx-auto max-w-5xl px-4 py-24 sm:px-8">
          <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-primary">About Costobuild</p>
          <motion.h1 initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
            className="mt-2 max-w-3xl font-heading text-4xl font-extrabold tracking-tighter sm:text-5xl lg:text-6xl">
            Construction estimating, democratized.
          </motion.h1>
          <p className="mt-5 max-w-2xl text-lg text-muted-foreground">
            Getting a reliable cost on a building used to mean weeks of back-and-forth with architects and
            contractors. Costobuild puts that power in anyone's hands — design a structure, upload a blueprint,
            and get a contractor-grade budget with real national pricing in minutes.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-4 py-20 sm:px-8">
        <div className="grid gap-4 md:grid-cols-3">
          {[
            { icon: Target, title: "Our mission", desc: "Make accurate, transparent construction costs accessible to every homeowner, developer and builder." },
            { icon: Zap, title: "Our approach", desc: "Pair AI vision and estimation models with real national pricing data — fast, clear, and honest about assumptions." },
            { icon: Users, title: "Who we serve", desc: "From first-time home builders to warehouse developers and commercial GCs across the country." },
          ].map((c, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.08 }} className="border border-border p-7">
              <c.icon className="mb-4 h-6 w-6 text-primary" />
              <h3 className="font-heading text-lg font-semibold">{c.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{c.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-2 border border-border sm:grid-cols-4">
          {[["6", "Building types"], ["10+", "Cost scopes"], ["AI", "Vision + estimation"], ["National", "Pricing"]].map(([v, l], i) => (
            <div key={i} className="border-r border-border p-6 last:border-r-0">
              <div className="font-mono2 text-3xl font-bold text-primary">{v}</div>
              <div className="font-mono2 text-xs uppercase tracking-widest text-muted-foreground">{l}</div>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <Link to="/register" data-testid="about-cta">
            <Button size="lg" className="rounded-sm bg-primary font-mono2 uppercase tracking-widest text-black hover:bg-primary/90">
              Join Costobuild
            </Button>
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
